<template>
    <div class="row" v-if="selectedStones.length > 0">
        <div class="container-fluid selected-stones">
            <div v-for="(stone, index) of selectedStones">
                <div class="main-stone-title" v-if="index == 0">{{ $t('build_your_jewel.selected_diamond') }}</div>
                <div v-else-if="index == 1" class="other-stone-title mt-3">{{ $t('build_your_jewel.selected_pairs') }}
                </div>
                <div class="row stone-row">
                    <div class="col-md-8">{{ stone.cartItem.description }}</div>
                    <div class="col-md-4"><!--{{ formatPrice(stone.cartItem.amount * retailPerc) }}-->
                        <button class="btn edit-stone-btn" @click="changeStone(stone, index)">{{ $t('build_your_jewel.edit_stone') }}</button>
                    </div>
                </div>
            </div>
            <div class="container-fluid" v-if="selectedStones.length != stonesNumber">
                <div class="row pairs-title">
                    <div class="col-md-12">{{ $t('build_your_jewel.selectPairs') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Vue from "vue";

export default {
    name: "BuildYourJewelSelectedStones",
    data: function () {
        return {
        }
    },
    computed: {
        ...mapState({
            selectedStones: (state) => state.buildYourJewel.selectedStones,
            stonesNumber: (state) => state.buildYourJewel.stonesNumber,
            retailPerc: (state) => state.detail.retailPerc,
        })
    },
    methods: {
        ...mapMutations("buildYourJewel", [
            "setSelectedStones"
        ]),
        ...mapActions("stones", [
            "setQuery",
        ]),
        changeStone: function (stone, index) {
            if (index == 0)
                this.setSelectedStones([]);
            else
                this.setSelectedStones(this.selectedStones.filter(s => s.id != stone.id));
        },
        formatPrice: function (price) {
            return Vue.formatPrice(price) + "€";
        }
    },
    created() {
    },
    destroyed() {
    },
    watch: {
        selectedStones: {
            handler: function (newValue, oldValue) {
                if (newValue.length > 0 && newValue.length < this.stonesNumber)
                    this.$emit("changeSelectedStones")
            },
            deep: true,
        },
    },
}

</script>

<style lang="scss" scoped>
.selected-stones {
    background-color: white;
    text-align: left;
    padding-bottom: 20px;
}

.main-stone-title,
.other-stone-title {
    font-family: var(--secondary-font-family);
    padding-bottom: 10px;
    font-size: 1.5em;
    text-transform: uppercase;
    text-align: left;
}

.other-stone-title {
    font-size: 1.3em;
}

.stone-row {
    margin-bottom: 10px;
    line-height: 40px;
}

.pairs-title {
    font-family: var(--secondary-font-family);
    padding-bottom: 0px;
    margin-top: 30px;
    font-size: 1.5em;
    text-transform: uppercase;
    text-align: center;
}

.change-stone {
    margin-left: 5px;
    cursor: pointer;
}

.edit-stone-btn {
    background-color: var(--primary-color-1) !important;
    color: white !important;
    text-transform: uppercase;
    margin-left: 10px;
}
</style>